export const getNameInitial = (name) => {
  if (typeof name !== 'string') {
    return ''
  }

  const trimmedName = name.trim()

  if (!trimmedName) {
    return ''
  }

  const nameParts = trimmedName.split(/\s+/).filter(Boolean)

  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase()
  }

  return nameParts
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('')
}
